module.exports = __webpack_public_path__ + "img/specialty01.23cf4310.png";